var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import styled, { css, } from 'styled-components';
import { propsToForward } from '../tools/utils';
import { FormFieldHelper } from '../FormFieldHelper';
var initialState = {
    align: 'stacked',
    variant: 'single-select',
    selectedKeys: [],
    showError: false,
    customErrorId: '',
    childIndex: function (key) { return 0; },
    onSelected: function (key) {
        /* noop */
    },
    onKeyDown: function (e, key) {
        /* noop */
    },
    /**
     * Initial guess at child count is 3.
     * Will be updated in component below on mount.
     */
    hideIconSmDown: false,
    inlineCardWidth: undefined,
    inlineCardHeight: undefined,
    inlineCardAlignment: 'flex-start',
};
var stackedStyles = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var $align = _a.$align;
    if ($align === 'stacked') {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        flex-direction: column;\n        justify-content: stretch;\n        grid-template-columns: repeat(auto-fill, 1fr);\n        grid-auto-rows: auto;\n      "], ["\n        flex-direction: column;\n        justify-content: stretch;\n        grid-template-columns: repeat(auto-fill, 1fr);\n        grid-auto-rows: auto;\n      "])));
    }
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
});
var inlineStyles = css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "}\n"], ["\n  ", "}\n"])), function (props) {
    var $align = props.$align, space = props.theme.space;
    if ($align === 'inline') {
        var _a = props.$inline, cardWidth = _a.cardWidth, cardHeight = _a.cardHeight, cardColumnCount = _a.cardColumnCount;
        var gridGap = space.xs;
        var maxWidth = cardColumnCount
            ? css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            /*\n          depending on how many columns are used (if any), we must calculate the\n          total width of the container based on the width of the cards and the\n          extra width added by the grid gap\n         */\n            max-width: calc(\n              (", " * ", ") +\n                (", " * ", ")\n            );\n          "], ["\n            /*\n          depending on how many columns are used (if any), we must calculate the\n          total width of the container based on the width of the cards and the\n          extra width added by the grid gap\n         */\n            max-width: calc(\n              (", " * ", ") +\n                (", " * ", ")\n            );\n          "])), cardColumnCount, cardWidth, cardColumnCount - 1, gridGap) : css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            max-width: inherit;\n          "], ["\n            max-width: inherit;\n          "])));
        return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        flex-direction: row;\n        justify-content: flex-start;\n        grid-template-columns: repeat(auto-fill, ", ");\n        grid-auto-rows: ", ";\n        ", "\n      "], ["\n        flex-direction: row;\n        justify-content: flex-start;\n        grid-template-columns: repeat(auto-fill, ", ");\n        grid-auto-rows: ", ";\n        ", "\n      "])), cardWidth, cardHeight !== null && cardHeight !== void 0 ? cardHeight : 'auto', maxWidth);
    }
    return css(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
});
var StyledContainer = styled.div.withConfig({
    shouldForwardProp: propsToForward,
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var space = _a.theme.space;
    return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: grid;\n    grid-gap: ", ";\n    box-sizing: border-box;\n    width: 100%;\n    grid-auto-flow: row;\n    ", "\n    ", "\n  "], ["\n    display: grid;\n    grid-gap: ", ";\n    box-sizing: border-box;\n    width: 100%;\n    grid-auto-flow: row;\n    ", "\n    ", "\n  "])), space.xs, inlineStyles, stackedStyles);
});
export var GroupContext = React.createContext(initialState);
var contentAlignmentMap = {
    top: 'flex-start',
    center: 'center',
    bottom: 'flex-end',
};
var CardSelectionGroup = React.forwardRef(function (_a, ref) {
    var variant = _a.variant, align = _a.align, inline = _a.inline, onSelection = _a.onSelection, defaultSelection = _a.defaultSelection, _b = _a.allowDeselection, allowDeselection = _b === void 0 ? false : _b, _c = _a.hideIconSmDown, hideIconSmDown = _c === void 0 ? false : _c, errorNotification = _a.errorNotification, children = _a.children, ariaLabelledby = _a.ariaLabelledby, ariaRequired = _a.ariaRequired, others = __rest(_a, ["variant", "align", "inline", "onSelection", "defaultSelection", "allowDeselection", "hideIconSmDown", "errorNotification", "children", "ariaLabelledby", "ariaRequired"]);
    var prevDefaultSelection = React.useRef(defaultSelection);
    var outerRef = React.useRef(null);
    var _d = __read(useState([]), 2), selectedKeys = _d[0], setSelectedKeys = _d[1];
    var childCount = useMemo(function () { return children.length; }, [children]);
    var childIndex = useCallback(function (childKey) {
        return children.findIndex(function (item) { return item.props.cardId === childKey; });
    }, [children]);
    var onSelectionCallback = useCallback(function (newKeys) {
        if (variant === 'single-select') {
            ;
            onSelection(newKeys.length ? newKeys[0] : undefined);
        }
        else if (variant === 'multi-select') {
            ;
            onSelection(newKeys);
        }
    }, [variant, onSelection]);
    var removeKey = useCallback(function (key) {
        setSelectedKeys(function (keys) {
            var newKeys = keys.filter(function (k) { return k !== key; });
            onSelectionCallback(newKeys);
            return newKeys;
        });
    }, [setSelectedKeys, onSelectionCallback]);
    var handleSelection = useCallback(function (key, handleDuplicates) {
        if (handleDuplicates === void 0) { handleDuplicates = 'remove_duplicate'; }
        var includesKey = selectedKeys.includes(key);
        if (includesKey && (allowDeselection || variant === 'multi-select')) {
            if (handleDuplicates === 'ignore_duplicate')
                return undefined;
            if (handleDuplicates === 'remove_duplicate') {
                return removeKey(key);
            }
        }
        return setSelectedKeys(function (keys) {
            var newKeys = variant === 'single-select' ? [key] : __spreadArray(__spreadArray([], __read(keys), false), [key], false);
            onSelectionCallback(newKeys);
            return newKeys;
        });
    }, [
        removeKey,
        allowDeselection,
        variant,
        selectedKeys,
        setSelectedKeys,
        onSelectionCallback,
    ]);
    var onSelectPrev = useCallback(function (fromIndex) {
        var LAST_INDEX = childCount - 1;
        if (fromIndex > 0) {
            handleSelection(children[fromIndex - 1].props.cardId);
        }
        else {
            handleSelection(children[LAST_INDEX].props.cardId);
        }
    }, [children, childCount, handleSelection]);
    var onSelectNext = useCallback(function (fromIndex) {
        var LAST_INDEX = childCount - 1;
        if (fromIndex < LAST_INDEX) {
            handleSelection(children[fromIndex + 1].props.cardId);
        }
        else {
            handleSelection(children[0].props.cardId);
        }
    }, [children, childCount, handleSelection]);
    var hasDefaultSelectionChanged = React.useMemo(function () {
        var _a;
        if (!defaultSelection)
            return false;
        if (typeof defaultSelection === 'string') {
            var hasChanged = defaultSelection !== prevDefaultSelection.current;
            if (hasChanged)
                prevDefaultSelection.current = defaultSelection;
            return hasChanged;
        }
        if (Array.isArray(defaultSelection)) {
            if (defaultSelection.length !== ((_a = prevDefaultSelection.current) === null || _a === void 0 ? void 0 : _a.length)) {
                return true;
            }
        }
        return false;
    }, [defaultSelection, prevDefaultSelection]);
    useEffect(function () {
        if (!defaultSelection)
            return;
        if (typeof defaultSelection === 'string') {
            handleSelection(defaultSelection, 'ignore_duplicate');
        }
        else if (Array.isArray(defaultSelection)) {
            defaultSelection.forEach(function (selection) {
                handleSelection(selection, 'ignore_duplicate');
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasDefaultSelectionChanged]);
    var onKeyDownSingleSelect = function (e, cardId) {
        var fromIndex = childIndex(cardId);
        if (fromIndex >= 0) {
            var key = e.key;
            // left or up arrow keys
            if (['ArrowLeft', 'ArrowUp'].includes(key)) {
                onSelectPrev(fromIndex);
                e.preventDefault();
            }
            // right or down arrow keys
            if (['ArrowRight', 'ArrowDown'].includes(key)) {
                onSelectNext(fromIndex);
                e.preventDefault();
            }
        }
    };
    /**
     * With the `multi-select` variant, we don't want arrow navigation with the keyboard. Instead, we want the native
     * tab navigation, which is why this function is a no-op for `multi-select`.
     */
    var onKeyDownMultiSelect = function () {
        /* noop */
    };
    var onKeyDown = variant === 'single-select' ? onKeyDownSingleSelect : onKeyDownMultiSelect;
    var role = variant === 'single-select' ? 'radiogroup' : 'group';
    var defaultInnerRef = React.useRef();
    var combinedInnerRef = function (el) {
        if (typeof ref === 'function') {
            ref(el);
        }
        else if (ref) {
            ref.current = el;
        }
        defaultInnerRef.current = el;
    };
    var isAriaRequired = ariaRequired && variant !== 'multi-select'
        ? { 'aria-required': 'true' }
        : {};
    var _e = inline || {}, cardWidth = _e.cardWidth, cardHeight = _e.cardHeight, _f = _e.cardAlignment, cardAlignment = _f === void 0 ? 'top' : _f;
    return (React.createElement(GroupContext.Provider, { value: __assign(__assign({}, initialState), { align: align, variant: variant, selectedKeys: selectedKeys, showError: !!(errorNotification === null || errorNotification === void 0 ? void 0 : errorNotification.message), customErrorId: errorNotification === null || errorNotification === void 0 ? void 0 : errorNotification.customId, childIndex: childIndex, onSelected: function (key) { return handleSelection(key); }, onKeyDown: onKeyDown, hideIconSmDown: !!hideIconSmDown, defaultSelection: defaultSelection, inlineCardWidth: cardWidth, inlineCardAlignment: contentAlignmentMap[cardAlignment], inlineCardHeight: cardHeight }) },
        React.createElement("div", { ref: outerRef },
            React.createElement(StyledContainer, __assign({ ref: combinedInnerRef, role: role, "$align": align, "$inline": inline, "aria-labelledby": ariaLabelledby }, isAriaRequired, others), children)),
        React.createElement(FormFieldHelper, { errorNotification: __assign(__assign({}, (errorNotification || {})), { show: !!(errorNotification === null || errorNotification === void 0 ? void 0 : errorNotification.message) }) })));
});
var GroupForProps = function () { return React.createElement(React.Fragment, null); };
export { CardSelectionGroup, GroupForProps };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
//# sourceMappingURL=CardSelectionGroup.js.map